<template>
  <!-- NOTE LIST WITH ADD BUTTON MODAL -->
  <div class="notes-component">
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0 title">Notas de Usuario</h5>
        <a-button
          v-if="editingAllowed"
          type="primary"
          data-toggle="modal"
          data-target="#addNoteModal"
          @click="modalOpen = true"
        >
          Agregar Nota
        </a-button>
      </div>
      <div class="card-body">
        <a-list :data-source="notes">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta :description="item.created_by.email">
              <span slot="title" class="text-notes">{{ item.notes }}</span>
            </a-list-item-meta>
            <div>
              {{ $moment(item.created_at).format(dateTimeFormat) }}
            </div>
          </a-list-item>
          <!-- LOAD MORE BUTTON -->
          <a-button
            v-if="!loading && hasMore"
            @click="loadMore"
            block
            type="link"
            class="load-more"
          >
            Cargar más
          </a-button>

          <div v-if="loading" class="demo-loading-container">
            <a-spin />
          </div>
        </a-list>
      </div>
    </div>

    <!-- ADD NOTE MODAL -->
    <a-modal
      id="addNoteModal"
      title="Agregar Nota"
      ok-text="Guardar"
      cancel-text="Cancelar"
      :visible="modalOpen"
      @ok="addNote"
      @cancel="closeModal"
      :confirmLoading="submitting"
      :okButtonProps="{ disabled: submitting }"
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item label="Nota">
          <a-textarea v-model="form.notes" rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import _ from "lodash";
import { DATE_FORMAT } from "../utils/utils";
import { mapActions } from "vuex";

const DEFAULT_STATE = {
  notes: "",
};

export default {
  name: "NotesComponent",
  props: {
    userId: {
      type: Number,
      required: true,
    },
    editingAllowed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: _.cloneDeep(DEFAULT_STATE),
      loading: false,
      modalOpen: false,
      notes: [],
      pagination: {
        more: false,
        page: 1,
        limit: 5,
      },
      submitting: false,
    };
  },
  computed: {
    dateTimeFormat() {
      return DATE_FORMAT.MOMENT_DATE_TIME;
    },
    hasMore() {
      return this.pagination.more;
    },
  },
  methods: {
    ...mapActions("users", ["fetchNotes", "createNote"]),
    closeModal() {
      this.modalOpen = false;
      this.form = _.cloneDeep(DEFAULT_STATE);
    },
    async loadNotes() {
      if (this.loading) return;
      this.loading = true;
      try {
        const {
          data: { data = [], pagination },
        } = await this.fetchNotes({
          user_id: this.userId,
          page: this.pagination.page,
          limit: this.pagination.limit,
        });
        this.notes = [...this.notes, ...data];
        this.pagination = pagination;
      } catch (error) {
        this.$message.error("Error loading notes");
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      if (this.hasMore) {
        this.pagination.page += 1;
        this.loadNotes();
      }
    },
    async addNote() {
      if (this.submitting) return;
      this.submitting = true;
      if (!this.form.notes) {
        this.$message.error("El campo de notas no puede estar vacío.");
        return;
      }

      try {
        const formData = {
          notes: _.cloneDeep(this.form).notes,
          user_id: this.userId,
        };

        await this.createNote(formData);
        this.$message.success("Nota agregada exitosamente");
        this.form = _.cloneDeep(DEFAULT_STATE);
        this.modalOpen = false;
        this.pagination.page = 1;
        this.notes = [];
        this.$nextTick(() => {
          this.loadNotes();
        });
      } catch (error) {
        this.$message.error("Error al agregar la nota");
      } finally {
        this.submitting = false;
      }
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.userId) {
          this.pagination.page = 1;
          this.notes = [];
          this.loadNotes();
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.notes-component {
  .card {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    .d-flex {
      display: flex;
    }
    .justify-content-between {
      justify-content: space-between;
    }
    .align-items-center {
      align-items: center;
    }
    .card-header {
      background-color: #f5f5f5;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 15px;
      h5.title {
        margin-bottom: 0;
        font-size: 18px;
      }
    }
    .card-body {
      max-height: 436px;
      overflow-y: auto;
      padding: 15px;
      .load-more {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 500;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .text-notes {
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>
